import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError, map, delay } from 'rxjs/operators'; 
import * as moment from "moment";
import { environment } from './../../environments/environment';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
declare var $:any;

@Injectable({
  providedIn: 'root'
})
export class AdminapiService {
    apiURL = environment.apiUrl;
    apiURL2 = environment.apiUrl2;
    showLoader=false;
    newVideos:any;

    // Http Options
    httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Cache-Control':' no-cache, no-store, must-revalidate'
      }),
    };
    constructor(private http: HttpClient,private router: Router) {}

    setLoader(loading:boolean){
      this.showLoader=loading
    }

    slugify(string){
      return string.toString().toLowerCase()
      .replace(/\s+/g, '-')           // Replace spaces with -
      .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
      .replace(/\-\-+/g, '-')         // Replace multiple - with single -
      .replace(/^-+/, '')             // Trim - from start of text
      .replace(/-+$/, '');            // Trim - from end of text
    }
    
    getSubscriptions() {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/subscriptions/',
          pages: 5 // number of pages to cache
      } )
    }

    dashboardData(): Observable<any> {
      const idToken = sessionStorage.getItem("adminid_token");
      if(idToken){
        return this.http
          .get(this.apiURL + 'admin/dashboard/')
          .pipe(retry(1),
          delay(1000), catchError(this.handleError));
      }else{
        return new Observable
      }
    }

    getUserData(): Observable<any> {
      const idToken = sessionStorage.getItem("adminid_token");
      if(idToken){
        return this.http
          .get(this.apiURL + 'admin/userinfo/')
          .pipe(retry(1),
          delay(1000), catchError(this.handleError));
      }else{
        return new Observable
      }
    }

    getUsers() {
      // return this.http
      //   .post(this.apiURL + 'admin/usersdata/', data)
      //   .pipe(retry(1),
      //   delay(3000), catchError(this.handleError));
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/usersdata/',
          pages: 5 // number of pages to cache
      } )
    }
    
    getVideos(params) {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/videos/',
          data:params,
          pages: 5 // number of pages to cache
      } )
    }
    
    getSeriesVideos(params) {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/seriesvideos/',
          data:params,
          pages: 5 // number of pages to cache
      } )
    }

    loginas(data:any) {
      return this.http
        .post(this.apiURL + 'admin/loginas/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    getSelectedCatOptions(data){
      return this.http
        .get(this.apiURL + 'admin/selectedcatoptions/',{params:data})
        .pipe(retry(1),
        delay(3000), catchError(this.handleError));
    }

    getVideoFormData() {
      return this.http
        .get(this.apiURL + 'admin/getvideoformdata/')
        .pipe(retry(1),
        delay(3000), catchError(this.handleError));
    }

    getSeriesVideoFormData() {
      return this.http
        .get(this.apiURL + 'admin/getseriesvideoformdata/')
        .pipe(retry(1),
        delay(3000), catchError(this.handleError));
    }

    addSeriesVideo(data:any) {
      return this.http
        .post(this.apiURL2 + 'admin/addseriesvideo/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    addVideo(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addvideo/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    editUser(data:any) {
      return this.http
        .post(this.apiURL + 'admin/edituser/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    addUser(data:any) {
      return this.http
        .post(this.apiURL + 'admin/adduser/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    getCategories() {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/categories/',
          pages: 5 // number of pages to cache
      } )
    }

    addCategory(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addcategory/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    
    getSkills() {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/skills/',
          pages: 5 // number of pages to cache
      } )
    }

    addSkill(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addskill/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    
    getInstructors() {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/instructors/',
          pages: 5 // number of pages to cache
      } )
    }

    addInstructor(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addinstructor/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    
    getSignatureseries() {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/signatureseries/',
          pages: 5 // number of pages to cache
      } )
    }

    addSignatureseries(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addsignatureseries/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    
    getSignatureseriesFormData() {
      return this.http
        .get(this.apiURL + 'admin/getsignatureseriesformdata/')
        .pipe(retry(1),
        delay(3000), catchError(this.handleError));
    }
    
    getRules() {
      // return this.http
      //   .post(this.apiURL + 'admin/usersdata/', data)
      //   .pipe(retry(1),
      //   delay(3000), catchError(this.handleError));
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/rules/',
          pages: 5 // number of pages to cache
      } )
    }

    getRulesList() {
      return this.http
        .get(this.apiURL + 'admin/allrules/')
        .pipe(retry(1),
        delay(3000), catchError(this.handleError));
    }

    getCategoryFormData() {
      return this.http
        .get(this.apiURL + 'admin/getcategoryformdata/')
        .pipe(retry(1),
        delay(3000), catchError(this.handleError));
    }

    getSubscriptionFormData() {
      return this.http
        .get(this.apiURL + 'admin/getsubscriptionformdata/')
        .pipe(retry(1),
        delay(3000), catchError(this.handleError));
    }

    getUsersFormData() {
      return this.http
        .get(this.apiURL + 'admin/getusersformdata/')
        .pipe(retry(1),
        delay(3000), catchError(this.handleError));
    }
    
    addSubscription(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addsubscription/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    addRule(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addrule/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    
    getOptions() {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/options/',
          pages: 5 // number of pages to cache
      } )
    }

    addOption(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addoption/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    
    getChoices() {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/choices/',
          pages: 5 // number of pages to cache
      } )
    }

    addChoice(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addchoice/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    
    getLevels() {
      return $.fn.dataTable.pipeline( {
          url:  this.apiURL + 'admin/levels/',
          pages: 5 // number of pages to cache
      } )
    }

    
    getlevelrules(id:any) {
      return this.http
        .get(this.apiURL + 'admin/levelrules/'+id)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    addLevel(data:any) {
      return this.http
        .post(this.apiURL + 'admin/addlevel/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    commonDelete(table,id) {
      let data = {
        id,
        table
      }
      return this.http
        .post(this.apiURL + 'admin/commondelete/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    cancelSubscription(table,id) {
      let data = {
        id,
        table
      }
      return this.http
        .post(this.apiURL + 'admin/cancelSubscription/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    
    sendotp(data:any) {
      return this.http
        .post(this.apiURL + 'admin/sendotp/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    resetpassword(data:any) {
      return this.http
        .post(this.apiURL + 'admin/resetpassword/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    signup(data:any) {
      return this.http
        .post(this.apiURL + 'admin/signup/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    updateProfile(data:any) {
      return this.http
        .post(this.apiURL + 'admin/updateprofile/', data)
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }
    
    getMessage() {
      return this.http
        .get(this.apiURL + 'admin/getmessage/')
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }
    
    saveMessage(data:any){
      return this.http
        .post(this.apiURL + 'admin/savemessage/', data)
        .pipe(retry(0),
        delay(1000), catchError(this.handleError));
    }

    // authentication functions
    login(username:string, password:string ): Observable<any> {
      return this.http
        .post(this.apiURL + 'admin/login/', {username, password})
        .pipe(retry(1),
        delay(1000), catchError(this.handleError));
    }

    setSession(authResult:any) {
      const expiresAt = moment().add(authResult.expires_in,'days');
      //console.log('expiry',expiresAt)
      sessionStorage.setItem('adminid_token', authResult.token);
      sessionStorage.setItem('admindata', JSON.stringify(authResult));
      sessionStorage.setItem("admin_expires_at", JSON.stringify(expiresAt.valueOf()) );
    }  
    
    redirectTo(uri:string){
      this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
      this.router.navigate([uri]));
    }

    logout() {
        sessionStorage.removeItem("adminid_token");
        sessionStorage.removeItem("admindata");
        sessionStorage.removeItem("admin_expires_at");
        this.setLoader(true)
        this.router.navigateByUrl('/admin/login');
        this.setLoader(false)
    }

    public isLoggedIn() {
        return moment().isBefore(this.getExpiration());
    }

    isLoggedOut() {
        return !this.isLoggedIn();
    }

    getExpiration() {
        const expiration = sessionStorage.getItem("admin_expires_at") || '';
        const expiresAt = expiration ? JSON.parse(expiration) : null;
        let dateValue = null;
        return dateValue = expiresAt ? moment(expiresAt) : null;
    }  
    // end authentication functions

    // Error handling
    handleError(error: any) {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        // Get client-side error
        errorMessage = error.error.message;
      } else {
        // Get server-side error
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
      }
      //window.alert(errorMessage);
      return throwError(() => {
        return errorMessage;
      });
    }

    
    // trigger validation
    validateAllFields(formGroup: FormGroup) {
      Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {
          this.validateAllFields(control);
        }
      });
    }
    // trigger validation

    // get errors
    getErrors (formGroup: FormGroup, errors: any = {}) {
      Object.keys(formGroup.controls).forEach(field => {
        const control = formGroup.get(field);
        if (control instanceof FormControl) {
          errors[field] = control.errors;
        } else if (control instanceof FormGroup) {
          errors[field] = this.getErrors(control);
        }
      });
      return errors;
    }
    //get errors
}

